import type { PassengerPassengerTag } from '@bambi/api-client/schemas';

import { Tag } from 'src/common/tags/Tag/Tag';

export function PassengerInfoFormTags({
  tags,
}: {
  tags: PassengerPassengerTag[];
}) {
  return (
    <div className="mt-1 flex flex-row flex-wrap gap-1">
      {tags.map((tag) => (
        <Tag
          key={tag.id}
          label={tag.tag_name}
          color={tag.color_hex}
          data-testid={`passenger-tag-${tag.id}`}
        />
      ))}
    </div>
  );
}
